export function client_client(state) {
  return state.client_client;
}

export function type_services(state) {
  return state.type_services;
}


